import { useEffect, useState } from 'react';

type GoogleMapsScriptState = 'idle' | 'loading' | 'ready' | 'error';

const GOOGLE_MAPS_URL = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&libraries=places`;
export function useGoogleAPILoadingScript(): GoogleMapsScriptState {
  const [status, setStatus] = useState<GoogleMapsScriptState>(GOOGLE_MAPS_URL ? 'loading' : 'idle');

  useEffect((): void => {
    if (!GOOGLE_MAPS_URL) {
      setStatus('error');

      return;
    }

    // Check if script already exists
    let script: HTMLScriptElement | null = document.querySelector(
      `script[src="${GOOGLE_MAPS_URL}"]`,
    );

    if (!script) {
      script = document.createElement('script');
      script.src = GOOGLE_MAPS_URL;
      script.async = true;
      document.body.appendChild(script);

      script.onload = (): void => {
        setStatus('ready');
      };

      script.onerror = (): void => {
        setStatus('error');
      };
    } else {
      setStatus('ready');
    }
  }, []);

  return status;
}
